var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoCard',{attrs:{"title":"shipment.single"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('ID') + ': ' + _vm.shipment.id))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }